import { render } from "./fund.vue?vue&type=template&id=0b061a5c&scoped=true"
import script from "./fund.vue?vue&type=script&lang=js"
export * from "./fund.vue?vue&type=script&lang=js"

import "./fund.vue?vue&type=style&index=0&id=0b061a5c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b061a5c"]])

export default __exports__